const ITEMS = [
  "Fait maison",
  "Café de spécialité",
  "Torréfaction artisanale",
  "Pâtisseries de saison",
  "Produits bretons",
  "Place des Lices — Rennes",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-xl font-medium italic text-[#F5F0E6] sm:text-2xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-[#C85A32]" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-[#12281D] bg-[#1B3B2B] py-5"
    aria-hidden="true"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
